import { CLIENT_SET, CLIENT_RESET } from "../actionNames";

const initialState = {
  data: undefined,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case CLIENT_SET:
      return {
        ...state,
        data: action.client,
      };

    case CLIENT_RESET:
      return {
        ...state,
        data: undefined,
      };

    default:
      return state;
  }
};
